import {FirebaseService} from "../firebase/FirebaseService";
import {RequestPayload} from "../../app/sites/types/RequestPayload";

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * Service class that contains method for create operations
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 * @constructor
 */
export class CreateAtDatabaseService {
  /**
   * Creates a new delivery at the database and returns the trackingID
   * @param data
   */
  public static async createNewDelivery(data: RequestPayload): Promise<string> {
    const deliveryRef = FirebaseService.dbRef().deliveries();
    const trackingID: string = deliveryRef.push().key as string;

    await deliveryRef
      .child(trackingID)
      .update({
        ...data,
      })
      .catch((e) => {
        console.error(e);
        alert(e);
      });

    return trackingID;
  }
}
